import PubNub from "pubnub";

import { loggingContexts } from "../../root/modules/logs/data/logging-contexts.js";
import { log } from "../../root/modules/logs/log.js";
import { useMainStore } from "../store/mainStore.js";

const pubNubInstanceLog = log(loggingContexts.pubnubInstance);

export const getPubNubInstance = ({ channel, productKey }) => {
  pubNubInstanceLog.info("creating new PubNub instance", {
    channel,
    productKey,
  });

  const mainStore = useMainStore();

  const pubNubConfiguration = {
    publishKey: mainStore.publishKey,
    restore: true,
    subscribeKey: mainStore.subscribeKey,
    uuid: productKey,
  };

  pubNubInstanceLog.info("PubNub instance configuration", pubNubConfiguration);

  const pubnub = new PubNub(pubNubConfiguration);

  const channels = [channel];
  const groupChannel = mainStore.groupChannel;

  groupChannel && channels.push(groupChannel);

  const subscribeParameters = { channels };

  const lastTimetoken = mainStore.lastPubNubMessageTimetoken;

  const catchUpMaxAgeMs = 5 * 60 * 1000;

  const timetokenAgeMs =
    lastTimetoken && /^\d+$/.test(lastTimetoken)
      ? Date.now() - Number(lastTimetoken) / 10000
      : Infinity;

  if (timetokenAgeMs >= 0 && timetokenAgeMs < catchUpMaxAgeMs) {
    subscribeParameters.timetoken = lastTimetoken;

    pubNubInstanceLog.info("subscribing with catch-up timetoken", {
      timetoken: lastTimetoken,
    });
  }

  pubnub.subscribe(subscribeParameters);

  mainStore.pubnub = pubnub;

  return pubnub;
};
